export const AUTH_CONSTS = {
    LOG_IN: "LOG_IN",
    LOG_OUT: "LOG_OUT",
};
